'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.array-buffer.detached');



//////////////////
// WEBPACK FOOTER
// E:/Websites/eco-pest-group/app/public/wp-content/themes/pestaid-v2-4/node_modules/core-js/modules/esnext.array-buffer.detached.js
// module id = 677
// module chunks = 0